import { useState } from 'react';

const DEFAULT_COUNTRY = { name: 'United States', code: '1' };

export const useDropdownCountry = () => {
    const [country, setCountry] = useState(DEFAULT_COUNTRY);

    return { country, setCountry };
};
